"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRouterDom = require("react-router-dom");

var _UiContext = _interopRequireDefault(require("@UiContext"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _axios = _interopRequireDefault(require("axios"));

var _excluded = ["api", "lang"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useFilterAPI = function useFilterAPI(_ref) {
  var api = _ref.api,
      lang = _ref.lang,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)({
    _loading: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      filter = _useState2[0],
      setFilter = _useState2[1];

  var _useContext = (0, _react.useContext)(_UiContext.default),
      _useContext2 = _slicedToArray(_useContext, 1),
      ui = _useContext2[0];

  var _ui$_location = ui._location;
  _ui$_location = _ui$_location === void 0 ? {} : _ui$_location;
  var _pathname = _ui$_location.pathname;
  var location = (0, _reactRouterDom.useLocation)();
  var pathname = location.pathname;
  var isCurrentLocation = pathname === _pathname;
  (0, _react.useEffect)(function () {
    var controller = new AbortController();
    var signal = controller.signal;

    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _i2, _Object$entries, _Object$entries$_i, key, value, fetchURL, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = [];
                params.push("lang=".concat(lang));

                for (_i2 = 0, _Object$entries = Object.entries(props); _i2 < _Object$entries.length; _i2++) {
                  _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                  params.push("".concat(key, "=").concat(value));
                }

                fetchURL = "".concat(api, "?").concat(params.join("&"));
                _context.prev = 4;
                _context.next = 7;
                return _axios.default.get(fetchURL, {
                  signal: signal
                });

              case 7:
                response = _context.sent;

                if (!((response === null || response === void 0 ? void 0 : response.status) === 200)) {
                  _context.next = 11;
                  break;
                }

                setFilter(response === null || response === void 0 ? void 0 : response.data);
                return _context.abrupt("return");

              case 11:
                _context.next = 15;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);

              case 15:
                setFilter({});

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 13]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (api && lang && !(0, _isEmpty.default)(props) && isCurrentLocation) {
      fetchData();
    }

    return function () {
      controller.abort();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, isCurrentLocation, lang, JSON.stringify(props)]);
  return filter;
};

var _default = useFilterAPI;
exports.default = _default;